import styled from 'styled-components';

import { primitive } from '../../designTokens/primitives';
import { mediaQuery } from '../../globalStyles';

export const InlineAlertWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(p) => p.theme.token('background-inline-alert')};
  padding: ${primitive.$spacing3} 6%;
  width: 100%;

  @media ${mediaQuery.tablet} {
    padding: ${primitive.$spacing4};
  }
`;

export const IconWrapper = styled.div`
  width: 16px;

  @media ${mediaQuery.tablet} {
    width: 20px;
  }
`;
export const InlineAlertMessage = styled.p`
  padding-inline-start: ${primitive.$spacing2};
  font: ${(p) => p.theme.token('text-style-inline-alert')};
  color: ${(p) => p.theme.token('text-default')};
`;
